<template>
  <div :class="notificationContainerClass"
       id="notification-container"
       v-if="isShow">
    <div class="d-flex">
      <div class="pr-1 align-self-center notification-body">
        <strong :class="diagnosisClass">
          <i :class="notificationIconClass"/>
          {{ firstDiagnosis }}
          <template v-if="secondDiagnosis">
              <br>
              {{ secondDiagnosis }}
          </template>
        </strong>
        <a target="_blank"
           class="text-red-130 text-decoration-underline"
           :class="diagnosisLinkClass"
           :href="link.learn_more_href"
           v-if="link && link.learn_more_href"
           @click="openLearnMoreLink">
          {{ link.learn_more_title ?? 'Learn more' }}
        </a>
        <portal-target class="d-inline"
                       name="diagnosisButtons"
                       v-if="staticsLoaded && !statics.whitelabel && isMobile">
        </portal-target>
      </div>
      <div class="ml-auto d-flex flex-md-row flex-column justify-content-center align-items-center"
           v-if='staticsLoaded && !statics.whitelabel'>
        <portal-target name="diagnosisButtons"
                       v-if="!isMobile">
        </portal-target>
      </div>
    </div>

    <portal to="diagnosisButtons">
      <b-button class="text-nowrap"
                variant="primary"
                size="sm"
                v-if="link"
                @click="openDiagnosisLink">
        {{ link.title }}
      </b-button>

      <compact-btn customClass="fs-14 _500 position-relative not-focusable ml-2 text-red-130"
                   borderless
                   @clicked="close">
        <i class="fa fa-times"/>
      </compact-btn>
    </portal>
  </div>
</template>

<script>
import { hasBridge, sendToMain } from 'src/plugins/helpers/electron'
import { mapGetters, mapState } from 'vuex'
import { aclMixin, classicMixin, kycMixin } from 'src/plugins/mixins'
import * as CompanyIssues from 'src/constants/company-issues'
import CompactBtn from 'components/compact-btn'

export default {
  name: 'header-notification',

  components: { CompactBtn },

  mixins: [
    aclMixin,
    classicMixin,
    kycMixin
  ],

  computed: {
    ...mapState([
      'statics',
      'staticsLoaded',
      'isMobile'
    ]),

    ...mapState('cache', [
      'currentCompany'
    ]),

    ...mapGetters('auth', [
      'profile'
    ]),

    isShow () {
      return this.showNotification && this.diagnosis.length > 0
    },

    firstDiagnosis () {
      if (this.diagnosis.length > 0) {
        return this.diagnosis[0]
      }

      return 'We are having issues with your account and calls might not route at this time. Please contact support as soon as possible.'
    },

    secondDiagnosis () {
      if (this.diagnosis.length > 1 && this?.is10DlcError) {
        return this.diagnosis[1]
      }

      return ''
    },

    currentRouteName () {
      return this.$route.name
    },

    diagnosisClass () {
      const rightClass = !this.link?.learn_more_href ? 'mr-2' : ''

      return [
        rightClass
      ]
    },

    diagnosisLinkClass () {
      const mobileClass = this.isMobile ? 'mr-2' : ''

      return [
        mobileClass
      ]
    },

    notificationContainerClass () {
      const base = 'px-2 w-100 py-2 px-3 position-relative notification-container-header'
      return this.notification_type === 'info'
        ? `notification-info ${base}`
        : `bg-yellow-12 ${base}`
    },

    notificationIconClass () {
      return this.notification_type === 'info'
        ? 'fa fa-info-circle mr-1'
        : 'fa fa-exclamation-triangle mr-1'
    },

    is10DlcError () {
      return this.issueCodes.includes(CompanyIssues.ISSUE_A2P_10DLC_NOT_REGISTERED) ||
        this.issueCodes.includes(CompanyIssues.ISSUE_A2P_10DLC_INCOMPLETE) ||
        this.issueCodes.includes(CompanyIssues.ISSUE_BRAND_REGISTRATION_FAILED) ||
        this.issueCodes.includes(CompanyIssues.ISSUE_BRAND_NOT_REGISTERED) ||
        this.issueCodes.includes(CompanyIssues.ISSUE_BRAND_REGISTRATION_FAILED_TCR_ZERO)
    }
  },

  data: () => {
    return {
      issueCodes: [],
      diagnosis: [],
      link: null,
      notification_type: 'danger',
      showDiagnosis: false,
      showNotification: true,
      CompanyIssues
    }
  },

  mounted () {
    this.runDiagnosis()
  },

  methods: {
    runDiagnosis () {
      this.$axios.get(`/api/v1/status/diagnosis`).then(res => {
        this.issueCodes = res.data.issue_codes
        this.diagnosis = res.data.issues
        this.link = res.data.link
        this.notification_type = res.data.notification_type ?? 'danger'
        this.showDiagnosis = res.data.has_issues
      })
    },

    close () {
      this.showNotification = false
      this.$VueEvent.fire('headerNotificationClosed')
    },

    isAbsoluteURL (url) {
      let regEx = new RegExp('^(?:[a-z+]+:)?//', 'i')

      return regEx.test(url)
    },

    openDiagnosisLink (event) {
      if (event) {
        event.preventDefault()
      }
      this.openExternalUrl(this.getLink(this.link))
    },

    openLearnMoreLink (event) {
      event.preventDefault()
      this.openExternalUrl(this.link.learn_more_href)
    },

    openExternalUrl (url) {
      if (hasBridge()) {
        sendToMain('open_external_url', url)
        return
      }

      window.open(url, '_blank', 'noopener,noreferrer')
    },

    getLink (link) {
      if (!link.external || !this.isAbsoluteURL(link.href)) {
        return `${this.getClassicURL()}${link.href}`
      }

      return link.href
    }
  },
  watch: {
    isShow (value) {
      if (value) {
        document.body.classList.add('has-notification-banner')
      } else {
        document.body.classList.remove('has-notification-banner')
      }
    }
  }
}
</script>

<style scoped>
.notification-body {
  font-size: 13px;
  width: 75%;
}

#notification-container {
  z-index: 10;
}

.notification-info {
  background-color: #cce5ff;
  border-bottom: 1px solid #b8daff;
  color: #004085;
}
</style>
